"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    table: function table(props) {
      return {
        width: '836px',
        borderCollapse: 'separate',
        '& th.MuiTableCell-root, td.MuiTableCell-root': {
          fontSize: '14px',
          height: '54px'
        },
        '& th.MuiTableCell-head': {
          fontSize: '11px',
          textTransform: 'uppercase',
          fontWeight: typography.fontWeightSemiBold,
          letterSpacing: '1.65px',
          padding: props.padding || '12px',
          color: '#9A9A9A',
          backgroundColor: 'white',
          position: 'sticky',
          top: 0,
          zIndex: 1,
          '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%'
          }
        }
      };
    },
    tableRow: function tableRow(props) {
      return {
        '& > .MuiTableCell-root.MuiTableCell-body': {
          padding: props.padding || '12px',
          height: '100%',
          border: 'none',
          fontSize: '13px',
          borderBottom: '1px solid #EAEAEA'
        },
        '&:last-child > .MuiTableCell-root.MuiTableCell-body': {
          borderBottom: 'none'
        }
      };
    },
    tableRowError: function tableRowError(props) {
      return {
        '& > .MuiTableCell-root.MuiTableCell-body': {
          padding: props.padding || '12px',
          height: '100%',
          border: 'none',
          fontSize: '13px',
          borderBottom: '1px solid #EAEAEA',
          color: '#A62B23'
        },
        '&:last-child > .MuiTableCell-root.MuiTableCell-body': {
          borderBottom: 'none'
        }
      };
    },
    addAdditionalRow: function addAdditionalRow(props) {
      return {
        borderTop: '1px solid #EAEAEA',
        borderBottom: 'none',
        padding: '12px',
        cursor: 'pointer'
      };
    },
    addAdditionalRowDisabled: function addAdditionalRowDisabled(props) {
      return {
        borderTop: '1px solid #EAEAEA',
        borderBottom: 'none',
        padding: '12px',
        backgroundColor: '#F7F7F7',
        color: '#00000080'
      };
    },
    additionalRowSelect: function additionalRowSelect(props) {
      return {
        '&:hover': {
          backgroundColor: '#F7F7F7'
        }
      };
    },
    tooltip: {
      backgroundColor: '#222222',
      color: '#FFFFFF',
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px'
    },
    errorTooltip: {
      backgroundColor: '#222222',
      color: '#FFFFFF',
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      marginTop: '-15px'
    },
    error: {
      color: '#A62B23 !important'
    },
    clickable: {
      cursor: 'pointer'
    },
    link: {
      color: '#1E8777',
      fontWeight: 600
    },
    tableContainer: function tableContainer(props) {
      return _objectSpread({
        border: '1px solid #EAEAEA',
        borderRadius: '10px',
        width: '836px',
        overflowX: 'hidden'
      }, props.scrollable && {
        maxHeight: props.scrollableMaxHeight || '350px',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '6px',
          height: '8px'
        },
        '&::-webkit-scrollbar-track': {
          borderRadius: '10%',
          marginTop: '53px',
          borderTop: '1px solid #EAEAEA'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,.1)',
          borderRadius: '10px',
          '&:hover': {
            backgroundColor: '#22222280'
          }
        }
      });
    }
  };
}, {
  name: 'DynamicTable'
});
exports.useStyles = useStyles;